export default __webpack_public_path__ + "static/media/success.12d63a4e.wav";